import { render, staticRenderFns } from "./todo-list.vue?vue&type=template&id=7cb856b0&scoped=true&"
import script from "./todo-list.vue?vue&type=script&lang=js&"
export * from "./todo-list.vue?vue&type=script&lang=js&"
import style0 from "./todo-list.vue?vue&type=style&index=0&id=7cb856b0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb856b0",
  null
  
)

export default component.exports